
import React, { forwardRef } from 'react'

import './InputDropdownItem.scss'

interface Props {
  children: any
  onClick?: (e: any) => void
}

const InputDropdownItem = forwardRef(({ children, onClick }: Props, ref: any) => {

  return (
    <div
      ref={ref}
      className='input-dropdown-item'
      onClick={(e) => {
        e.preventDefault();
        onClick && onClick(e);
      }}
    >
      {children}
    </div>
  )
})

InputDropdownItem.displayName = 'InputDropdownItem'

export default InputDropdownItem
